import { useState } from "react";
import { Pencil, Loader2, MessageSquarePlus } from "lucide-react";

const MAX = 300;

// Toelichting bij één rij van Begroting vs realisatie; inline bewerken, max. 300 tekens.
export function VarianceNoteCell({ t, rowKey, text, canEdit, hint, onSave }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(text || "");
  const [busy, setBusy] = useState(false);
  const tid = rowKey.replace(/[^a-zA-Z0-9_-]/g, "_");

  const save = async () => {
    setBusy(true);
    try { await onSave(draft.trim()); setEditing(false); } finally { setBusy(false); }
  };
  const start = () => { setDraft(text || ""); setEditing(true); };

  if (editing) {
    return (
      <div className="space-y-1" data-testid={`variance-edit-${tid}`}>
        <textarea autoFocus value={draft} maxLength={MAX} rows={2} onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Escape") setEditing(false); if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) save(); }}
          data-testid={`variance-input-${tid}`} placeholder={t("Korte verklaring van de afwijking…")}
          className="w-full border-2 border-foreground bg-background px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-primary" />
        <div className="flex items-center justify-between gap-2">
          <span className="text-[10px] font-mono-num text-muted-foreground">{draft.length}/{MAX}</span>
          <div className="flex gap-1">
            <button type="button" onClick={() => setEditing(false)} data-testid={`variance-cancel-${tid}`}
              className="px-2 py-0.5 text-[11px] font-display uppercase font-bold border-2 border-foreground bg-background hover:bg-muted">{t("Annuleer")}</button>
            <button type="button" onClick={save} disabled={busy} data-testid={`variance-save-${tid}`}
              className="px-2 py-0.5 text-[11px] font-display uppercase font-bold border-2 border-foreground bg-primary text-primary-foreground inline-flex items-center gap-1 disabled:opacity-50">
              {busy && <Loader2 className="w-3 h-3 animate-spin" />}{t("Opslaan")}
            </button>
          </div>
        </div>
      </div>
    );
  }
  if (text) {
    return (
      <div className="flex items-start gap-2 group" data-testid={`variance-note-${tid}`}>
        <span className="text-xs leading-snug text-foreground not-italic whitespace-normal" title={text}>{text}</span>
        {canEdit && (
          <button type="button" onClick={start} data-testid={`variance-edit-btn-${tid}`} title={t("Toelichting bewerken")}
            className="opacity-40 group-hover:opacity-100 hover:text-primary shrink-0 mt-0.5"><Pencil className="w-3 h-3" /></button>
        )}
      </div>
    );
  }
  if (!canEdit) return <span className="text-muted-foreground/50">—</span>;
  if (hint) {
    return (
      <button type="button" onClick={start} data-testid={`variance-hint-${tid}`}
        className="inline-flex items-center gap-1 text-[10px] font-display uppercase font-bold tracking-widest text-secondary border border-dashed border-secondary/60 px-2 py-0.5 hover:bg-secondary/10 not-italic">
        <MessageSquarePlus className="w-3 h-3" /> {t("Verklaar")}
      </button>
    );
  }
  return (
    <button type="button" onClick={start} data-testid={`variance-add-${tid}`} title={t("Toelichting toevoegen")}
      className="opacity-30 hover:opacity-100 hover:text-primary"><Pencil className="w-3 h-3" /></button>
  );
}
